import { ROLES } from "../utils/acl";

export const MENU_MEMBER = [
  {
    key: "my_area",
    section: "My Area",
    items: [
      {
        key: "my_dashboard",
        label: "My Dashboard",
        icon: "bi-person-circle",
        to: "/me",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
      {
        key: "my_statement",
        label: "My Statement",
        icon: "bi-file-earmark-text",
        to: "/me/statement",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
      {
        key: "my_contributions",
        label: "My Contributions",
        icon: "bi-cash-coin",
        to: "/me/contributions",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
      {
        key: "my_loans",
        label: "My Loans",
        icon: "bi-bank",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
        children: [
          {
            key: "my_loans_list",
            label: "My Loans",
            icon: "bi-bank",
            to: "/me/loans",
          },
          {
            key: "loan_applications",
            label: "Loans Application",
            icon: "bi-bank",
            to: "/me/my-loan-applications",
          },
        ],
      },
      {
        key: "my_penalties",
        label: "My Penalties",
        icon: "bi-exclamation-triangle",
        to: "/me/penalties",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
      {
        key: "my_withdrawals",
        label: "My Withdrawals",
        icon: "bi-wallet2",
        to: "/me/withdrawals",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
    ],
  },
];

export const MENU_ADMIN = [
  {
    key: "administration",
    section: "Administration",
    roles: [ROLES.ADMIN, ROLES.TREASURER],
    items: [
      {
        key: "admin_overview",
        label: "Admin Overview",
        icon: "bi-speedometer2",
        to: "/admin",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
      },
      {
        key: "members",
        label: "Members",
        icon: "bi-people",
        to: "/admin/members",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
      },
      {
        key: "finance",
        label: "Finance",
        icon: "bi-wallet2",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
        children: [
          {
            key: "statement",
            label: "Statement",
            icon: "bi-file-earmark-text",
            to: "/admin/statement",
          },
          {
            key: "contributions",
            label: "Contributions",
            icon: "bi-cash-coin",
            to: "/admin/contributions",
          },
          {
            key: "expenses",
            label: "Expenses",
            icon: "bi-receipt",
            to: "/admin/expenses",
          },
          {
            key: "penalties",
            label: "Penalties",
            icon: "bi-exclamation-triangle",
            to: "/admin/penalties",
          },
          {
            key: "withdrawals",
            label: "Withdrawals",
            icon: "bi-cash-stack",
            to: "/admin/withdrawals",
          },
          {
            key: "reconciliation",
            label: "Reconciliation",
            icon: "bi-clipboard-check",
            to: "/admin/reconciliation",
          },
          {
            key: "matrix_report",
            label: "Matrix Report",
            icon: "bi-table",
            to: "/admin/reports/monthly-matrix",
          },
        ],
      },
      {
        key: "loans",
        label: "Loans",
        icon: "bi-bank",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
        children: [
          {
            key: "all_loans",
            label: "All Loans",
            icon: "bi-list",
            to: "/admin/loans",
          },
          {
            key: "repayment_sheet",
            label: "Repayment Sheet",
            icon: "bi-table",
            to: "/admin/loans/repayment-sheet",
          },
          {
            key: "bulk_loan_migration",
            label: "Bulk Loan Migration",
            icon: "bi-upload",
            to: "/admin/loans/import",
          },
          {
            key: "loan_applications_review",
            label: "Loan Applications Review",
            icon: "bi-clipboard-check",
            to: "/admin/loan-applications-review",
          },
        ],
      },
      {
        key: "investments",
        label: "Investments",
        icon: "bi-briefcase",
        to: "/admin/investments",
        roles: ["owner", "admin", "treasurer"],
        requiresInvestmentEnabled: true,
      },
      {
        key: "commitments",
        label: "Commitments",
        icon: "bi-check2-circle",
        to: "/admin/commitments",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
      },
      {
        key: "settings",
        label: "Settings",
        icon: "bi-gear",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
        children: [
          {
            key: "financial_years",
            label: "Financial Years",
            icon: "bi-calendar-range",
            to: "/admin/settings/financial-years",
            roles: [ROLES.ADMIN, ROLES.TREASURER],
          },
          {
            key: "fy_closure",
            label: "FY Closure",
            icon: "bi-calendar2-check",
            to: "/admin/financial-year-closures",
            roles: [ROLES.ADMIN, ROLES.TREASURER],
          },
          {
            key: "group_rules",
            label: "Group Rules",
            icon: "bi-sliders",
            to: "/admin/settings/rules",
            roles: [ROLES.ADMIN],
          },
        ],
      },
    ],
  },
];
